var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showing)?_c('div',{ref:"interactElement",class:[
    _vm.$style.card,
    ( _obj = {}, _obj[_vm.$style.animated] = _vm.interactAnimating, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.isCurrent] = _vm.isCurrent, _obj$1 )
  ],style:({ transform: _vm.transformString })},[_c('div',[_c('h3',{class:_vm.$style.cardTitle},[_vm._v("\n      "+_vm._s(_vm.card.keyword)+"\n    ")]),_c('ul',{class:_vm.$style.cardWordsList},_vm._l((_vm.card.forbiddenWords),function(word){return _c('li',{key:word},[_vm._v("\n        "+_vm._s(word)+"\n      ")])}))])]):_vm._e()
var _obj;
var _obj$1;}
var staticRenderFns = []

export { render, staticRenderFns }